const base_url = `https://gameskenya.h2ndigital.com`;
// const base_url =  ``;
export {base_url}



const subscribe_api = `${base_url}/subscribe-user`
export {subscribe_api}

const updateStatusApi = `${base_url}/update/activation-logs`
export {updateStatusApi}

const getHeadersApi = `${base_url}/get-headers`
export {getHeadersApi}